export function yardsToMiles(value: number): number {
  return Math.round((value / 1760) * 100) / 100;
}
